import { s_tutors } from '../../../../modules/i18n/strings/auto/wording'
import useTranslation from '../../../../modules/i18n/useTranslation'
import { IMG_NO_VIDEO } from '../../../../modules/images'

const getFormattedDates = (time, timezone) => {
  const utcDate = new Date(time)
  const localDate = new Date(utcDate.toLocaleString('en-US', { timeZone: timezone }))
  const year = localDate.getFullYear()
  const month = localDate.getMonth() + 1
  const day = localDate.getDate()
  return { year, month, day }
}

const TutorVideo = ({ data }: { data: any }) => {
  const { t } = useTranslation()

  if (!data) return null
  const time = data.video_uploaded_at?.time
  const timezone = data.video_uploaded_at?.timezone
  const video_uploaded_at = getFormattedDates(time, timezone)
  return (
    <div className="max-w-screen col-12 relative mx-auto flex max-h-[180px] overflow-hidden p-[0px] text-center sm:max-h-[320px]">
      {data.video_link || data.video_url_webm ? (
        <>
          <video
            className="mx-auto cursor-pointer rounded-[8px] bg-black"
            width="100%"
            controlsList="nodownload"
            controls
            poster={data.thumbnail_link}
            preload="auto"
            onContextMenu={(e) => e.preventDefault()}
          >
            <source src={data.video_link} type="video/mp4" />
            {data.video_url_webm && <source src={data.video_url_webm} type="video/webm" />}
          </video>
          <span className="absolute top-16 right-16 text-sm text-white">
            {t(s_tutors.video_updated_at(video_uploaded_at.year, video_uploaded_at.month, video_uploaded_at.day))}
          </span>
        </>
      ) : (
        <div className="flex h-full w-full items-center justify-center p-[20px]">
          <div>
            <img src={IMG_NO_VIDEO} className="w-full" />
            <span className="text-muted mt-3 w-full text-center">{t(s_tutors.video_preparing)}</span>
          </div>
        </div>
      )}
    </div>
  )
}
export default TutorVideo
